var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5006 20.5L7.50065 16.75V12.4833L0.833984 4.98333V3C0.833984 2.33696 1.09738 1.70107 1.56622 1.23223C2.03506 0.763392 2.67094 0.5 3.33398 0.5L16.6673 0.5C17.3304 0.5 17.9662 0.763392 18.4351 1.23223C18.9039 1.70107 19.1673 2.33696 19.1673 3V4.98333L12.5006 12.4833V20.5ZM9.16732 15.9167L10.834 17.1667V11.85L17.5006 4.35V3C17.5006 2.77899 17.4129 2.56702 17.2566 2.41074C17.1003 2.25446 16.8883 2.16667 16.6673 2.16667H3.33398C3.11297 2.16667 2.90101 2.25446 2.74473 2.41074C2.58845 2.56702 2.50065 2.77899 2.50065 3V4.35L9.16732 11.85V15.9167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.3090c6c5d9efb5dd2ffe70b34f2ceb58.svg";
export { ForwardRef as ReactComponent };